<template>
  <v-container fluid>
    <material-card
      icon="mdi-clipboard-text"
      inline
      title="View Registration Details"
    >
      <v-card-actions>
        <v-chip class="ma-2 float-right" color="primary">
          Type: {{ formData.type }}
        </v-chip>
        <a @click="$router.back()">
          <v-btn
            v-if="$vuetify.breakpoint.smAndUp"
            elevation="1"
            absolute
            right
            top
          >
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn
            v-else
            fixed
            right
            fab
            small
            color="grey lighten-2"
            elevation="1"
            class="mr-n2 mt-10"
            style="opacity: 0.6"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </a>
      </v-card-actions>
      <v-card-component>
        <form autocomplete="off">
          <v-row>
            <v-col cols="4" lg="4">
              <label>Training Title </label>
              <v-text-field
                required
                v-model="formData.title"
                placeholder="Title"
                disabled
              >
              </v-text-field>
            </v-col>
            <v-col cols="4" lg="4">
              <label> From Date </label>
              <v-text-field
                required
                v-model="formData.fromDate"
                placeholder="Title"
                disabled
              >
              </v-text-field>
            </v-col>
            <v-col cols="4" lg="4">
              <label> To Date </label>
              <v-text-field
                required
                v-model="formData.toDate"
                placeholder="Title"
                disabled
              >
              </v-text-field>
            </v-col>
            <v-col cols="4" lg="4">
              <label> From Time </label>
              <v-text-field
                required
                prepend-icon="mdi-clock-time-four-outline"
                v-model="formData.fromTime"
                placeholder="Title"
                disabled
              >
              </v-text-field>
            </v-col>
            <v-col cols="4" lg="4">
              <label> To Time </label>
              <v-text-field
                required
                prepend-icon="mdi-clock-time-four-outline"
                v-model="formData.toTime"
                placeholder="Title"
                disabled
              >
              </v-text-field>
            </v-col>
            <v-col cols="4" lg="4">
              <label for="select">Select Zone </label>
              <v-text-field required v-model="formData.zone" disabled>
              </v-text-field>
            </v-col>
            <v-col cols="4" lg="4">
              <label for="selectS">Select States </label>
              <v-text-field required v-model="formData.state" disabled>
              </v-text-field>
            </v-col>
            <v-col cols="4" lg="4">
              <label for="selectC">Select Cities </label>
              <v-text-field required v-model="formData.city" disabled>
              </v-text-field>
            </v-col>
            <v-col cols="4" lg="4">
              <label for="selectCe">Centers eligible for training</label>
              <v-autocomplete
                disabled
                v-model="formData.franchiseeIds"
                name="sCenter"
                :items="selectedCenter"
                item-text="companyName"
                item-value="id"
                key="id"
                multiple
                @input="onCenterSelect()"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="4" lg="4">
              <label for="selectCl">Select Class Group</label>
              <v-autocomplete
                disabled
                id="selectCl"
                v-model="formData.classGroupIDs"
                name="sClass"
                :items="classData"
                item-text="name"
                item-value="id"
                key="id"
                multiple
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="4" lg="4" v-show="formData.type === 'offline'">
              <label for="selectClo">Training Location</label>
              <v-autocomplete
                disabled
                id="selectClo"
                name="sLocation"
                required
                :items="selectedLocation"
                item-text="companyName"
                item-value="id"
                key="id"
                v-model="formData.locationCenterID"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="4" lg="4">
              <label for="selectT">Select Trainers</label>
              <v-autocomplete
                disabled
                id="selectT"
                v-model="formData.trainerIds"
                name="sTrainer"
                :items="selectedTrainer"
                item-text="firstName"
                item-value="id"
                key="id"
                multiple
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="4" lg="4">
              <label for="selectB">Batch Size</label>
              <v-text-field
                disabled
                id="selectB"
                name="sBatch"
                required
                v-model="formData.batchSize"
                key="id"
              >
              </v-text-field>
            </v-col>
            <v-col cols="4" lg="4">
              <label> Registration End Date </label>
              <custom-date-picker
                disabled
                v-model="formData.registrationEndDate"
              />
            </v-col>
          </v-row>
        </form>

        <!--Received enrolments-->
        <template>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Staff Name</th>
                  <!-- <th class="text-left">
            Centre, City Name
          </th> -->
                  <th class="text-left">Response</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in allRSVPData" :key="item.name">
                  <td>
                    {{ item.user.firstName + '   ' + item.user.lastName }}
                  </td>
                  <!-- <td>{{ item.trainingByTrainerFranchiseeMap.franchisee.companyName }}</td> -->
                  <td>{{ item.response }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>
        <!-- <div class="mt-2"></div> -->
        <!-- <div v-for="(item,i) in centersEligibleFor" :key="i">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{item.franchisee.companyName}}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-col cols="6">
                  <v-list-item v-for="(teacher, k) in allRSVPData" :key="k">
                    <v-list-item-icon>
                      <v-icon>mdi-account</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{teacher.user.firstName}} {{teacher.user.lastName}}
                       </v-list-item-title>

                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div> -->
      </v-card-component>
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
import VCardComponent from '../template/VCardComponent.vue'
import MaterialCard from '@/components/template/MaterialCard'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import moment from 'moment'
import { mapGetters } from 'vuex'
import constants from '@/utils/constants'
import _ from 'lodash'

export default {
  name: 'editTeacherTraining',
  props: ['id'],
  components: {
    VCardComponent,
    MaterialCard,
    CustomDatePicker
  },
  data: function () {
    return {
      formData: {
        id: '',
        title: '',
        type: 'offline',
        fromDate: '',
        toDate: '',
        fromTime: '',
        toTime: '',
        state: '', // NA
        zone: '',
        city: '', // NA
        franchiseeIds: [],
        classGroupIDs: [],
        trainerIds: [],
        locationCenterID: '',
        batchSize: '',
        registrationEndDate: ''
      },
      enrolments: {},
      centersEligibleFor: [],
      selectedZones: [],
      selectedCity: [],
      selectedState: [],
      selectedCenter: [],
      selectedTrainer: [],
      selectedLocation: [],
      disabled: false,
      classData: [],
      isLoading: false,
      yesterday: '',
      allRSVPData: {}
    }
  },
  mounted: async function () {
    console.log(`ID: ${this.id}`)
  },

  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },

  async created () {
    try {
      await this.getTrainingDetails()
      await this.getZoneDetails()
      await this.getAllTrainerList()
      await this.getClassData()
    } catch (e) {
      console.log(e)
    }
  },

  methods: {
    async getTrainingDetails () {
      try {
        const { data } = await http.get(
          `${constants.API_URL}/api/teacher-training/get-training/${this.id}`
        )
        this.formData = {
          id: data.id,
          title: data.title,
          type: data.type,
          fromDate: moment(data.fromDate).format('YYYY-MM-DD'),
          toDate: moment(data.toDate).format('YYYY-MM-DD'),
          fromTime: data.fromTime.substring(0, data.fromTime.length - 3),
          toTime: data.toTime.substring(0, data.toTime.length - 3),
          state: JSON.parse(data.state), // NA
          zone: data.zone.toString().replace('[', '').replace(']', ''),
          city: JSON.parse(data.city), // NA
          franchiseeIds: _.map(
            data.trainingByTrainerFranchiseeMaps,
            (a) => a.franchiseeId
          ),
          classGroupIDs: _.map(
            data.trainingByTrainerClassgroupMaps,
            (a) => a.classGroupID
          ),
          trainerIds: _.map(data.trainingTrainerMaps, (a) => a.trainerUserID),
          locationCenterID: data.locationCenterID,
          batchSize: data.batchSize,
          registrationEndDate: moment(data.registrationEndDate).format(
            'YYYY-MM-DD'
          )
        }
        this.yesterday = moment(this.formData.fromDate)
          .add(-1, 'days')
          .format('YYYY-MM-DD')
          .toString()
        this.centersEligibleFor = data.trainingByTrainerFranchiseeMaps
        this.enrolments = _.groupBy(
          data.trainingByTrainersEnrollments,
          'trainingFranchiseeMapID'
        )

        this.allRSVPData = this.enrolments.undefined

        this.onZoneSelect()
        this.onStateSelect()
        this.onCitySelect()
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    onZoneSelect () {
      this.getStateDetails()
    },

    onStateSelect () {
      this.getCityDetails()
    },

    onCitySelect () {
      this.getCenterDetails()
    },
    onCenterSelect () {
      this.getClassData()
    },

    onClassSelect () {
      this.getAllTrainerList()
    },

    getZoneDetails: async function () {
      try {
        this.isLoading = true
        let result = await http.get(
          `${constants.API_URL}/api/teacher-training/zone-options`
        )

        this.selectedZones = result.data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },

    getStateDetails: async function () {
      this.isLoading = true
      let zone = this.formData.zone

      let res = await http.post(
        `${constants.API_URL}/api/teacher-training/state-options`,
        { zone }
      )

      this.selectedState = res.data
      this.isLoading = false
    },

    getCityDetails: async function () {
      this.isLoading = true
      let states = []
      states = this.formData.state
      let res = await http.post(
        `${constants.API_URL}/api/teacher-training/city-options`,
        { states }
      )

      this.selectedCity = res.data
      this.isLoading = false
    },

    getCenterDetails: async function () {
      this.isLoading = true
      let cities = []
      cities = this.formData.city
      let res = await http.post(
        `${constants.API_URL}/api/teacher-training/franchisee-options`,
        { cities }
      )
      this.selectedCenter = res.data
      this.selectedLocation = this.selectedCenter
      this.isLoading = false
    },
    getClassData: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(
          `${constants.API_URL}/api/student/getclass-group`
        )
        this.isLoading = false
        data = _.filter(data, (e) => {
          return (
            e.type === constants.ClassGroupTypes.teacherTraining &&
            e.isActive === true
          )
        })
        this.classData = data
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },

    getAllTrainerList: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(
          `${constants.API_URL}/api/teacher-training/trainer-options`
        )
        this.isLoading = false
        this.selectedTrainer = data
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
